import { useAuth } from "../../utils/AuthContext";
import { createBoard } from "../../utils/boards";

interface BoardsHeaderProps {}

const BoardsHeader: React.FC<BoardsHeaderProps> = () => {
  const { currentUser } = useAuth();

  const handleCreateBoard = async () => {
    try {
      if (!currentUser) throw new Error("User not authenticated");

      const newBoardId = await createBoard(currentUser.uid, {
        pictures: [], // start with an empty board
        thumbnail: "https://example.com/path/to/thumbnail.png",
      });
      console.log("New board created with id:", newBoardId);
      // Optionally, update UI or show a notification here.
    } catch (err) {
      console.error("Board creation failed:", err);
    }
  };

  return (
    <header className="flex flex-col justify-between gap-4 max-w-[100vw] px-4 py-8">
      <h1 className="font-bold text-5xl">Tableaux</h1>
      <button
        tabIndex={0}
        className="text-sm font-medium py-2 px-4 rounded-full bg-neutral-900 text-neutral-50 w-max"
        onClick={handleCreateBoard}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            handleCreateBoard(); // <-- Now calling the function!
          }
        }}
      >
        Create board
      </button>
    </header>
  );
};

export default BoardsHeader;
